export enum PromotionType {
  PERCENTAGE_OFF = "percentage_off",
  AMOUNT_OFF = "amount_off",
  BUY_X_GET_Y = "buy_x_get_y",
  MIX_AND_MATCH = "mix_and_match",
  BUNDLE_PRICE = "bundle_price",
  ORDER_PERCENTAGE_OFF = "order_percentage_off",
  ORDER_AMOUNT_OFF = "order_amount_off",
  FREE_DELIVERY = "free_delivery",
}

export enum PromotionTargetType {
  ALL = "all",
  PRODUCT = "product",
  CATEGORY = "category",
  SUB_CATEGORY = "sub_category",
  BRAND = "brand",
  SUPPLIER = "supplier",
}
